import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

function TestScreen2() {
  const sentMessages = 450;
  const receivedMessages = 550;
  const totalMessages = 1000;
  const sentPct = Math.round((sentMessages / totalMessages) * 100);

  const messagesData = [
    { name: 'Sent', value: sentMessages, color: '#a78bfa' },
    { name: 'Received', value: receivedMessages, color: '#f9a8d4' },
  ];

  return (
    <div className="p-4 bg-white rounded-b-xl w-full min-h-full flex flex-col items-center justify-center">

      {/* Header */}
      <div className="text-center mb-1">
        <p className="text-[10px] text-gray-400 font-medium uppercase tracking-widest">All time</p>
        <h3 className="text-sm font-black text-gray-900 tracking-tight">Your Message Breakdown</h3>
      </div>

      {/* Donut chart */}
      <div className="relative my-2">
        <ResponsiveContainer width={180} height={180}>
          <PieChart>
            <Pie
              data={messagesData}
              cx="50%"
              cy="50%"
              innerRadius={52}
              outerRadius={78}
              paddingAngle={3}
              dataKey="value"
              animationDuration={1200}
              strokeWidth={0}
            >
              {messagesData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="text-xl font-black text-gray-900">{totalMessages.toLocaleString()}</div>
          <div className="text-[9px] text-gray-400 font-medium">total messages</div>
        </div>
      </div>

      {/* Legend */}
      <div className="flex gap-6 mb-4">
        <div className="flex items-center gap-2">
          <div className="w-2.5 h-2.5 rounded-full bg-violet-400" />
          <div>
            <div className="text-sm font-black text-gray-900">{sentMessages}</div>
            <div className="text-[9px] text-gray-400">Sent ({sentPct}%)</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-2.5 h-2.5 rounded-full bg-pink-300" />
          <div>
            <div className="text-sm font-black text-gray-900">{receivedMessages}</div>
            <div className="text-[9px] text-gray-400">Received ({100 - sentPct}%)</div>
          </div>
        </div>
      </div>

      {/* Comment */}
      <div className="bg-violet-50 border border-violet-100 rounded-xl px-4 py-2.5 text-center w-full">
        <p className="text-[10px] font-bold text-violet-700">You're perfectly balanced ⚖️</p>
        <p className="text-[9px] text-gray-500 mt-0.5 font-serif italic">You and your matches share the conversation load equally</p>
      </div>

    </div>
  );
}

export default TestScreen2;
